class OrderSupplierQuote {
	constructor() {
		this.supplier = null
		this.dispatch_location = null
		this.order_items = []
		this.supplier_invoices = null

		this.supplier_po_amount = 0
		this.supplier_po_date = null
		this.supplier_po_document = null
		this.supplier_po_number = null
		this.supplier_po_status = null
		this.terms =
			'1. PRICES ARE F.O.R AT SITE AND EXCLUSIVE OF TAXES\n2. ENDORSED TEST CERTIFICATES TO BE PROVIDED BEFORE DISPATCH\n3. WEIGHT TOLERANCE :- +/- 0.5% OF INVOICED WEIGHT\n4. DELIVERY CONDITIONS :- IMMEDIATE\n5. TCS IS NOT APPLICABLE, TDS TO BE CHARGED WHILE MAKING THE PAYMENT AGAINST THE BILLS.\n6. UNLOADING EXTRA UNDER THE SCOPE OF THE BUYER\n'
	
	}
}

export default OrderSupplierQuote
